import { application } from "./application"
import GlobeController from "./globe_controller"
application.register("globe", GlobeController)